// src/components/PrivateRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = () => {
    // Verifica se o token existe no armazenamento local
    const token = localStorage.getItem('token');
    
    // Se tiver token, libera a passagem (Outlet mostra as rotas filhas)
    // Se não tiver, redireciona para a rota /login
    return token ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;